<template>
  <div class="section-header" :class="'--is-' + textAlign + '-aligned'">
    <h2 class="section-header__title"><slot name="title" /></h2>

    <div
      v-if="$slots.description"
      class="section-header__description"
    >
      <slot name="description" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    textAlign: {
      type: String,
      default: 'center'
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * SectionHeader
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Section's header styles
 * @since 2021-04-13
**/

$component: 'section-header';

.#{$component} {
  @include margin-bottom(map-get($spacers, 4) * 3);

  &__title {
    @include margin-bottom(map-get($spacers, 4));
    @include font-size(map-get($landing-page, 'font-size-title'));
    font-weight: $font-weight-bolder;
  }

  &__description {
    @include font-size($font-size-xl);
    line-height: 170%;
    font-weight: $font-weight-light;

    p {
      margin: 0;

      & + & {
        @include margin-top(map-get($spacers, 3));
      }

      // When a button/CTA is placed right after
      & + .btn {
        @include margin-top(map-get($spacers, 5));
      }
    }
  }

  &.--is-left-aligned {
    text-align: left;
  }

  &.--is-center-aligned {
    text-align: center;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    &__section-heading {
      @include margin-bottom(map-get($spacers, 4) * 5);
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    &.--is-center-aligned {
      width: 100%;
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
